import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import { styled } from "@mui/system";

const StyledCard = styled(Card)({
  background: "rgba(27, 38, 59, 0.8)", // Glassmorphism effect
  backdropFilter: "blur(10px)",
  borderRadius: "15px",
  padding: "20px",
  color: "#00f5d4",
  boxShadow: "0px 0px 10px rgba(0, 245, 212, 0.5)",
  textAlign: "center",
  transition: "0.3s",
  width: "250px", // Set a fixed width
  height: "200px", // Set a fixed height
  display: "flex", // Ensure the card takes the full available space
  flexDirection: "column", // Stack content vertically
  justifyContent: "space-between", // Space out the content
  "&:hover": {
    transform: "scale(1.05)",
    boxShadow: "0px 0px 20px rgba(0, 245, 212, 0.8)",
  },
});

const KpiCard = ({ title, value, icon }) => {
  return (
    <StyledCard>
      <CardContent>
        <Box display="flex" justifyContent="center" alignItems="center" mb={1}>
          {icon}
        </Box>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="h4" fontWeight="bold">
          {value}
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

export default KpiCard;
